const about = {
	introHeading: "Hi, my name is Christina Song",
	introContent: [
		"I'm a 4th year computer science student at the University of Ottawa, and I am seeking a full time software developer role with a start date in summer 2025.",
		"I have hands-on experience in web development, working extensively with React, TypeScript, and JavaScript to build and optimize user interfaces. My background includes API development using Spring Boot and AWS DynamoDB, as well as automating network configurations and enhancing testing infrastructures in Python. I've also worked with C# and WPF to create user interfaces and applications for device interaction and lab automation.",
		"My roles have honed my ability to manage projects, collaborate with cross-functional teams, and ensure high code quality through testing frameworks like JUnit, Mockito, Jest, and Enzyme.",
	],
	outsideWorkHeading: "Outside of Work",
	outsideWorkContent: [
		"When I'm not glued to my screens, I like to stay active. I did long distance running for 3 years and even ran the Ottawa Tamarack Marathon in May 2023. Currently, I mainly weightlift since I realized I enjoy it more than running.",
		"I also enjoy reading and going on long walks in the city. My favourite genres are fantasy and sci-fi.",
	],
};

export default about;
